<template>
  <div>
    <JobExecModal ref="JobExecModal"></JobExecModal>
  </div>
</template>

<script>
import { getOpsCenterJobUnfinishedExecLog, execOpsCenterJob } from '@/api/opscenter'
import JobExecModal from './job-exec-modal'

export default {
  name: 'job-exec-confirm',
  components: {
    JobExecModal
  },
  data () {
    return {
      jobId: ''
    }
  },
  methods: {
    // 执行作业
    exec (id) {
      this.jobId = id
      this.getUnfinishedExecLogData()
    },
    // 获取未完成执行日志信息
    getUnfinishedExecLogData () {
      getOpsCenterJobUnfinishedExecLog({ job: this.jobId }).then(res => {
        if (res.data) {
          this.$Notice.warning({
            title: '操作失败！',
            desc: '当前作业正在执行，不允许重复执行'
          })
        } else {
          this.$Modal.confirm({
            title: '确定执行该作业吗？',
            onOk: () => {
              this.startExec()
            }
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败，获取执行数据失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 开始执行
    startExec () {
      let reqData = {
        job: this.jobId
      }
      execOpsCenterJob(reqData).then(res => {
        this.$emit('execComplete')
        this.$Notice.success({ title: '操作成功，作业开始执行！' })
        this.$refs.JobExecModal.openExecModal(res.data.log_id, this.jobId)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
